import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LoanNotes } from "@app/models/loan-notes";
import { LoansNotesService } from "@app/services/loans-notes.service";

@Component({
    selector: "app-loan-note-node",
    templateUrl: "./loan-note-node.component.html",
    styleUrls: ["./loan-note-node.component.css"],
    standalone: false
})
export class LoanNoteNodeComponent implements OnInit {
  @Input() level: number;
  @Input() loanNotes: Array<LoanNotes>;
  @Input() selectedLoanNotes: Array<LoanNotes>;
  @Output() onAddLoanNote = new EventEmitter<LoanNotes>();
  @Output() onDeleteLoanNote = new EventEmitter<LoanNotes>();

  constructor(private loanNoteService: LoansNotesService) {}

  ngOnInit(): void {}

  changeNoteStatus(item, value) {
    if (value.target.checked) {
      this.addLoanNote(item);
    } else {
      this.deleteLoanNote(item);
    }
  }

  addLoanNote(item) {
    this.onAddLoanNote.emit(item);
  }

  deleteLoanNote(item) {
    this.onDeleteLoanNote.emit(item);
  }

  isSelectedLoanNote(item) {
    var parents = [];
    for (var i = 0; i < this.selectedLoanNotes.length; i++) {
      var selectedLoanNote = this.loanNoteService.findLoanNoteById(this.selectedLoanNotes[i].id, this.loanNotes);
      var parents = parents.concat(this.loanNoteService.findLoanNoteParents(selectedLoanNote, this.loanNotes));
    }
    var sParents = new Set(parents.map(p => p.id));
    return sParents.has(item.id);
  }
}
